import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { loginRequest } from './auth/msal';
import { AppShell } from './components/AppShell';
import { MagicGate } from './components/MagicGate';
import { authConfigured, authMode } from './config';
import { CsatPage } from './pages/CsatPage';
import { KbArticlePage } from './pages/KbArticlePage';
import { KbListPage } from './pages/KbListPage';
import { MyTicketsPage } from './pages/MyTicketsPage';
import { NewTicketPage } from './pages/NewTicketPage';
import { TicketPage } from './pages/TicketPage';

function Loading() {
  return (
    <Box sx={{ display: 'grid', placeItems: 'center', height: '100vh', gap: 2 }}>
      <CircularProgress />
      <Typography color="text.secondary">Signing you in…</Typography>
    </Box>
  );
}

/** Layout route that applies the auth gate + app shell to everything under it. */
function GatedShell() {
  const shell = (
    <AppShell>
      <Outlet />
    </AppShell>
  );
  if (authMode === 'magic') return <MagicGate>{shell}</MagicGate>;
  if (!authConfigured) return shell; // dev mode — no sign-in
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={loginRequest}
      loadingComponent={Loading}
    >
      {shell}
    </MsalAuthenticationTemplate>
  );
}

export function App() {
  return (
    <Routes>
      {/* Public: satisfaction survey reached via an emailed token link. */}
      <Route path="/csat/:token" element={<CsatPage />} />
      <Route element={<GatedShell />}>
        <Route path="/" element={<Navigate to="/tickets" replace />} />
        <Route path="/tickets" element={<MyTicketsPage />} />
        <Route path="/tickets/new" element={<NewTicketPage />} />
        <Route path="/tickets/:id" element={<TicketPage />} />
        <Route path="/kb" element={<KbListPage />} />
        <Route path="/kb/:slug" element={<KbArticlePage />} />
        <Route path="*" element={<Navigate to="/tickets" replace />} />
      </Route>
    </Routes>
  );
}
